import { BrowserRouter } from 'react-router-dom'
import { AuthProvider, ThemeProvider, ToastProvider } from 'grabbitbot-legacy-ui'
import { apiClient } from './api/client'
import { AppRoutes } from './routes/AppRoutes'
import { TestDeploymentBanner } from './layout/TestDeploymentBanner'

export function App() {
  return (
    <ThemeProvider>
      <TestDeploymentBanner />
      <ToastProvider>
        <AuthProvider client={apiClient}>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  )
}
